
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/visio-to-figjam",
      function () {
        return require("private-next-pages/converter/visio-to-figjam.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/visio-to-figjam"])
      });
    }
  